<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data: () => ({})
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue